import { InteractionManager } from '@/SDK/InteractionManager';
import { UI_VERSION } from './generated-version';

/**
 * Get UI version from git tag
 */
export const getUIVersion = (): string => {
	return UI_VERSION;
};

/**
 * Get backend version from API
 */
export const getBackendVersion = async (): Promise<string> => {
	try {
		const api = InteractionManager.getInstance().API;
		const response = await api.versionGet();

		// Return version in format: Version (GitTag) or just Version
		if (response.Version) {
			return response.GitTag
				? `${response.Version} (${response.GitTag})`
				: response.Version;
		}

		// Fallback to GitTag if Version is not available
		return response.GitTag || 'Unknown';
	} catch (error) {
		console.error('Failed to fetch backend version:', error);
		return 'Unavailable';
	}
};

/**
 * Get both UI and backend versions
 */
export const getVersionInfo = async () => {
	const uiVersion = getUIVersion();
	const backendVersion = await getBackendVersion();

	return {
		ui: uiVersion,
		backend: backendVersion,
	};
};
